import React from 'react';
import Auxiliary from '../../../util/Auxiliary';
import QRCode from 'qrcode.react';
import { Button } from 'antd';

const PassportQR = ({ passport }) => {

  const downloadQR = () => {
    const canvas = document.getElementById('qr-code');

    const url = canvas.toDataURL("image/png");
    let link = document.createElement('a');
    link.download = `${passport.number}-${passport.name}.png`;
    link.href = url;
    link.click();
  }

  return (
    <Auxiliary>
      <div className="gx-mt-3">
        <div>
          <QRCode value={passport.number} size={256} id={`qr-code`}/>
        </div>
        <div className="gx-mt-2">
          <Button type="primary" block ghost onClick={downloadQR} >Download QR Code</Button>
        </div>
      </div>
    </Auxiliary>
  );
}

export default PassportQR;